//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { ConfigSystemParams, Duration, eSimApiPaths } from 'src/app/core/consts';
import { ConfigSystemService } from '../config-system/config-system-service';
import { EncryptionService } from '../../general/encryption-service';
import { environment } from 'src/environments/environment';
import { ESIMEventLogDTO } from 'src/app/core/models/system/webbing/esim-event-log.dto';
import { EsimLocationDTO } from 'src/app/core/models/system/webbing/esim-location.dto';
import { EsimLogProfileDTO } from 'src/app/core/models/system/webbing/esim-log-profile.dto';
import { ExceptionsService } from '../../general/exceptions-service';
import { HttpClientService } from '../../general/http-client-service';
import { Injectable } from '@angular/core';
import { interval, Observable, of, startWith, switchMap } from 'rxjs';
import { NetworkEventRecordDTO } from 'src/app/core/models/system/webbing/network-event-record.dto';
import { OurDate } from 'src/app/core/interfaces/general/our-date';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';
import { WebbingLiveDataDTO } from 'src/app/core/models/system/webbing/live-data.dto';

@Injectable({ providedIn: 'root' })

export class WebbingService {
  
  constructor(
    private configSystemService: ConfigSystemService,
    private encryptionService  : EncryptionService,
    private exceptionsService  : ExceptionsService,
    private httpClientService  : HttpClientService
  ) { }

  public getCompanySIMLocations(companyId        : number,
                                accuracyLevel    : number =0,
                                homeGuardPreview : number =-1,
                                excludeIotDevices: boolean=false,
                                keepKnownCountry : boolean=false): Observable<EsimLocationDTO[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(companyId.toString(), true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;

                            return this.httpClientService.get<EsimLocationDTO[]>(environment.eSimApi +
                                                                                 eSimApiPaths.Webbing + '/' +
                                                                                 eSimApiPaths.WebbingGetCompanySIMLocations +
                                                                                 "?companyIdEncSS=" + companyIdEncSS +
                                                                                 "&accuracyLevel=" + accuracyLevel +
                                                                                 "&homeGuardPreview=" + homeGuardPreview +
                                                                                 (excludeIotDevices ? "&excludeIotDevices=true" : "") +
                                                                                 (keepKnownCountry  ? "&keepKnownCountry=true"  : ""));
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getCurrentLocation(iccid: string, accuracyLevel: number = 0, homeGuardPreview: number = -1, trackingPreview: number = -1): Observable<EsimLocationDTO[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(iccid, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const iccidEncSS=encResult.result;

                            return this.httpClientService.get<EsimLocationDTO[]>(environment.eSimApi +
                                                                                 eSimApiPaths.Webbing + '/' +
                                                                                 eSimApiPaths.WebbingGetLocation +
                                                                                 "?iccidEncSS=" + iccidEncSS +
                                                                                 "&accuracyLevel=" + accuracyLevel +
                                                                                 "&homeGuardPreview=" + homeGuardPreview +
                                                                                 "&trackingPreview=" + trackingPreview);
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getSIMLocations(iccid: string, accuracyLevel: number = 0, homeGuardPreview: number = -1, trackingPreview: number = -1, fromMs: number = 0, toMs: number = 0): Observable<EsimLocationDTO[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(iccid, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const iccidEncSS=encResult.result;

                            return this.httpClientService.get<EsimLocationDTO[]>(environment.eSimApi +
                                                                                 eSimApiPaths.Webbing + '/' +
                                                                                 eSimApiPaths.WebbingGetSIMLocations +
                                                                                 "?iccidEncSS=" + iccidEncSS +
                                                                                 "&accuracyLevel=" + accuracyLevel +
                                                                                 "&homeGuardPreview=" + homeGuardPreview +
                                                                                 "&trackingPreview=" + trackingPreview +
                                                                                 "&fromMs=" + fromMs +
                                                                                 "&toMs=" + toMs);
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
  
  public getEsimLogProfile(iccid: string, orderid: number): Observable<EsimLogProfileDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(iccid, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const iccidEncSS=encResult.result;
                            
                            return this.httpClientService.get<EsimLogProfileDTO>(environment.eSimApi +
                                                                                 eSimApiPaths.Webbing + '/' +
                                                                                 eSimApiPaths.WebbingGetESIMLogProfile +
                                                                                 "?iccidEncSS=" + iccidEncSS +
                                                                                 "&orderid=" + orderid); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
  
  public getLiveDataByIccid(iccid: string): Observable<WebbingLiveDataDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(iccid, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const iccidEncSS=encResult.result;
                            
                            return this.httpClientService.get<WebbingLiveDataDTO>(environment.eSimApi +
                                                                                  eSimApiPaths.Webbing + '/' +
                                                                                  eSimApiPaths.WebbingGetSDLiveData + "?" +
                                                                                  "iccidEncSS=" + iccidEncSS); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
      
  public getLiveDataByIccidUpdates(iccid: string): Observable<WebbingLiveDataDTO> {
    try {
      return interval(this.configSystemService.getValueAsInteger(ConfigSystemParams.PollObservableWebbingLiveDataMilliSecs, Duration._1MinMilli))
             .pipe(startWith(0),
                   switchMap(() => this.getLiveDataByIccid(iccid))
            )
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
  
  public getNetworkEventRecordsBySimAndDateRange(iccid    : string,
                                                 orderid  : number,
                                                 startDate: OurDate,
                                                 endDate  : OurDate): Observable<NetworkEventRecordDTO[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(iccid, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const iccidEncSS=encResult.result;
                            
                            return this.httpClientService.get<NetworkEventRecordDTO[]>(environment.eSimApi +
                                                                                       eSimApiPaths.Webbing + '/' +
                                                                                       eSimApiPaths.WebbingGetNetworkEventsBySimAndDate +
                                                                                       "?iccidEncSS=" + iccidEncSS +
                                                                                       "&orderid=" + orderid +
                                                                                       `&eventstartdate=${startDate.year}-${startDate.month}-${startDate.day}` +
                                                                                       `&eventenddate=${endDate.year}-${endDate.month}-${endDate.day}`); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getStatusByIccid(iccid: string): Observable<ESIMEventLogDTO[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(iccid, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const iccidEncSS=encResult.result;
                            
                            return this.httpClientService.get<ESIMEventLogDTO[]>(environment.eSimApi +
                                                                                 eSimApiPaths.Webbing + '/' +
                                                                                 eSimApiPaths.WebbingGetESIMEventLogs +
                                                                                 "?iccidEncSS=" + iccidEncSS); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public SetProduct(iccid: string, productId: number): Observable<string[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(iccid, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const iccidEncSS=encResult.result;

                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.Webbing + '/' +
                                                               eSimApiPaths.WebbingSetProduct +
                                                               "?iccidEncSS=" + iccidEncSS +
                                                               "&productid=" + productId,
                                                               iccidEncSS);
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public ResetNetwork(iccid: string, currentProductId: number, userId: number): Observable<string> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(iccid, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const iccidEncSS=encResult.result;

                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.Webbing + '/' +
                                                               eSimApiPaths.WebbingResetNetwork +
                                                               "?iccidEncSS=" + iccidEncSS +
                                                               "&productid=" + currentProductId +
                                                               "&updatedByUserId=" + userId,
                                                               iccidEncSS);
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
